import { useMediaQuery, Theme, Box } from "@mui/material";
import { addYears, startOfDay } from "date-fns";
import React, { useMemo } from "react";
import { usePortfolioStatisticsByAssetClass } from "@api/v1/hooks/performance/usePortfolioStatisticsByAssetClass";
import { Carousel } from "@components";
import { AssetTypeCard } from "./AssetTypeCard/AssetTypeCard";
import { useAssetTypeData } from "./useAssetTypeData";

export interface Props {
  accountIds: number[];
}

export const AssetTypeBreakdown = ({ accountIds }: Props) => {
  const isSm = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));
  const startDate = startOfDay(addYears(new Date(), -1));

  const { allHoldings, funds, etfs, derivative, bonds, isFetching, isPending } =
    usePortfolioStatisticsByAssetClass({
      accountIds,
      startDate,
    });
  const isLoading = isFetching || isPending;

  const assetTypeData = useAssetTypeData({
    allHoldings,
    funds,
    etfs,
    derivative,
    bonds,
  });

  const filteredData = useMemo(() => {
    return isLoading
      ? assetTypeData
      : assetTypeData.filter(
          (data) =>
            data.hasData &&
            data.amount != null &&
            data.percent != null &&
            data.increase != null
        );
  }, [assetTypeData, isLoading]);

  const cards = filteredData.map((data, index) => (
    <AssetTypeCard
      key={index}
      isFetching={isLoading}
      title={data.title}
      amount={data.amount}
      increase={data.increase}
      percent={data.percent}
      changeAbs={data.changeAbs}
      color={data.color}
    />
  ));

  if (isSm) {
    return <Carousel>{cards}</Carousel>;
  }

  return (
    <Box display="flex" flexDirection="row" flexWrap="wrap" gap={2.5} mb={7}>
      {cards}
    </Box>
  );
};
